// extracted by mini-css-extract-plugin
export default {"figure":"Icon_figure__uLCnc","icon":"Icon_icon__ThgeH","icon-text":"Icon_icon-text__tsMCf"};